import React, { Component } from 'react'
import { Row, Col, Card, Button, Container, Form, Modal } from "react-bootstrap";
import SelectDropDown from '../selectdropdown/SelectDropDown'
import CardLessDataTableWithOutSearch from '../datatables/CardLessDataTableWithOutSearch';
import gql from "graphql-tag";
import { graphql } from "react-apollo";
import * as Cookies from "es-cookie";
import * as compose from "lodash.flowright";
import { withRouter } from "react-router-dom";
import { components } from 'react-select'
import moment, { invalid } from "moment";
import MultiSelect from "react-multi-select-component";
import "./_singleRequest.scss"


const ADD_CREATE_GROUP_WISE_PERMISSIONS = gql`
  mutation($params: AddPermissionDetails) {
    createGroupWisePermissions(params: $params)
  }`


const DropdownIndicator = props => {
    return (
        components.DropdownIndicator && (
            <components.DropdownIndicator {...props}>
                <svg height="20" width="20" viewBox="0 0 20 20" aria-hidden="true" focusable="false" className="css-6q0nyr-Svg"><path fill="currentColor" d="M4.516 7.548c0.436-0.446 1.043-0.481 1.576 0l3.908 3.747 3.908-3.747c0.533-0.481 1.141-0.446 1.574 0 0.436 0.445 0.408 1.197 0 1.615-0.406 0.418-4.695 4.502-4.695 4.502-0.217 0.223-0.502 0.335-0.787 0.335s-0.57-0.112-0.789-0.335c0 0-4.287-4.084-4.695-4.502s-0.436-1.17 0-1.615z"></path></svg>
            </components.DropdownIndicator>
        )
    );
};

class MultipleRequestModal extends Component {
    constructor() {
        super()
        this.state = {
            branch: "",
            branchSearch: "0",
            branchSearchval: "",

            exam: "",
            getExamArr: [],
            examError: "",
            examSelectedvalue: [],

            class: "",
            classError: "",
            getClassArr: [],
            classSelectedvalue: [],

            section: "",
            sectionError: "",
            getSectionArr: [],
            sectionSelectedvalue: [],

            fromDate: "",
            fromDateError: "",

            toDate: "",
            toDateError: "",

            dataClear: 0,
            requestMessage: "",
            loader: 0,
            submitError: "",
            submitted: false,
            eventName: "",
            eventError: ""
        }
    }


    componentDidUpdate() {
        if (this.props.show === true && this.state.dataClear == 0) {
            this.setState({
                examError: "",
                classError: "",
                sectionError: "",
                fromDate: "",
                fromDateError: "",
                toDate: "",
                toDateError: "",
                dataClear: 1,
                requestMessage: "",
                loader: 0,
                submitError: "",
                submitted: false,
                eventName: "",
                eventError: ""
            })
        }
        if (this.props.show === false && this.state.dataClear == 1) {
            this.setState({ dataClear: 0 })
        }
    }


    componentDidMount() {

        let branchData = this.props.globals.globalBranches;

        let getExamArr = [];
        let getClassArr = [];
        let getSectionArr = [];

        if (branchData.length > 0) {
            // Exams selection
            let uniqueExams = [...new Set(this.props.globals.b_e_c_s_data.filter((item) => item.branch_id == branchData[0].id).map((item1) => item1.exam_id))].sort();

            uniqueExams.map((val) => {
                let individualExamData = this.props.globals.exams.find((item1) => item1.id == val);
                const newObj = {
                    value: individualExamData.id,
                    label: individualExamData.exam
                }
                getExamArr.push(newObj);
            });

            //Class selection

            let selectedExamsValues = getExamArr.map((item) => item.value);

            let uniqueClasses = [];

            if (selectedExamsValues.length > 0) {

                selectedExamsValues.map((val) => {
                    let individualClassValues = [...new Set(this.props.globals.b_e_c_s_data.filter((item) => item.branch_id == branchData[0].id && item.exam_id == parseInt(val)).map((item1) => item1.class_id))].sort();
                    uniqueClasses.push(...individualClassValues)
                });
            }

            if (uniqueClasses.length > 0) {
                [...new Set(uniqueClasses)].map((val) => {
                    let individualClassData = this.props.globals.educationalClasses.find((item1) => item1.id == val);
                    const newObj = {
                        value: individualClassData.id,
                        label: individualClassData.class
                    }
                    getClassArr.push(newObj);
                });

                let selectedClasses = getClassArr.map((item) => item.value);


                //section selection

                let uniqueSections = [];

                if (selectedClasses.length > 0) {
                    selectedExamsValues.map((val) => {
                        selectedClasses.map((val1) => {
                            let individualsectionValues = [...new Set(this.props.globals.b_e_c_s_data.filter((item) => item.branch_id == branchData[0].id && item.exam_id == parseInt(val) && item.class_id == parseInt(val1)).map((item1) => item1.section_id))].sort();
                            if (individualsectionValues.length > 0) {
                                uniqueSections.push(...individualsectionValues)
                            }
                        })
                    });
                }

                if (uniqueSections.length > 0) {
                    [...new Set(uniqueSections)].map((val) => {
                        let individualSectionData = this.props.globals.globalSections.find((item1) => item1.id == val);
                        const newObj = {
                            value: individualSectionData.id,
                            label: individualSectionData.section_name
                        }
                        getSectionArr.push(newObj);
                    });
                }
            }

            this.setState({
                branchSearchval: {
                    value: branchData[0].id,
                    label: branchData[0].branch_name
                },
                branch: branchData[0].branch_name,
                branchSearch: branchData[0].id,
                getExamArr: getExamArr,
                examSelectedvalue: getExamArr,
                getClassArr: getClassArr,
                classSelectedvalue: getClassArr,
                getSectionArr: getSectionArr,
                sectionSelectedvalue: getSectionArr,
            });
        }

    }


    handleMultipleSelectInputChange = (e, name) => {

        console.log("multipleChange", e, name);


        if (name == "class") {

            let classSelectedvalue = [];
            let getSectionArr = [];

            if (e.length > 0) {
                for (let i = 0; i < e.length; i++) {
                    const classval = e[i];
                    const newObj = {
                        label: classval.label,
                        value: classval.value,
                    }
                    classSelectedvalue.push(newObj);
                }

                let selectedExamsValues = this.state.examSelectedvalue.map((item) => item.value);
                let selectedClasses = classSelectedvalue.map((item) => item.value);
                let uniqueSections = [];

                if (selectedClasses.length > 0) {
                    selectedExamsValues.map((val) => {
                        selectedClasses.map((val1) => {
                            let individualsectionValues = [...new Set(this.props.globals.b_e_c_s_data.filter((item) => item.branch_id == this.state.branchSearch && item.exam_id == parseInt(val) && item.class_id == parseInt(val1)).map((item1) => item1.section_id))].sort();
                            if (individualsectionValues.length > 0) {
                                uniqueSections.push(...individualsectionValues)
                            }
                        })
                    });
                }

                if (uniqueSections.length > 0) {
                    [...new Set(uniqueSections)].map((val) => {
                        let individualSectionData = this.props.globals.globalSections.find((item1) => item1.id == val);
                        const newObj = {
                            value: individualSectionData.id,
                            label: individualSectionData.section_name
                        }
                        getSectionArr.push(newObj);
                    });
                }


                this.setState({
                    classSelectedvalue: classSelectedvalue,
                    classError: "",
                    getSectionArr: getSectionArr,
                    sectionSelectedvalue: getSectionArr,
                    sectionError:"",
                    fromDateError:"",
                    toDateError:"",
                    fromDate:"",
                    toDate:""
                });
            } else {
                this.setState({
                    classSelectedvalue: classSelectedvalue,
                    classError: "",
                    getSectionArr: [],
                    sectionSelectedvalue: [],
                    sectionError:"",
                    fromDateError:"",
                    toDateError:"",
                    fromDate:"",
                    toDate:""
                });
            }
        }

        if (name == "exam") {
            let examSelectedvalue = [];

            if (e.length > 0) {

                for (let i = 0; i < e.length; i++) {
                    const examval = e[i];
                    const newObj = {
                        label: examval.label,
                        value: examval.value,
                    }
                    examSelectedvalue.push(newObj);
                }


                let selectedExamsValues = examSelectedvalue.map((item) => item.value);

                let uniqueClasses = [];
                let getClassArr = [];
                let getSectionArr = [];


                if (selectedExamsValues.length > 0) {

                    selectedExamsValues.map((val) => {
                        let individualClassValues = [...new Set(this.props.globals.b_e_c_s_data.filter((item) => item.branch_id == this.state.branchSearch && item.exam_id == parseInt(val)).map((item1) => item1.class_id))].sort();
                        console.log("individualClassValues", individualClassValues);
                        uniqueClasses.push(...individualClassValues)
                    });
                }



                if (uniqueClasses.length > 0) {
                    [...new Set(uniqueClasses)].map((val) => {

                        console.log("uniqueClasses", val);

                        let individualClassData = this.props.globals.educationalClasses.find((item1) => item1.id == val);
                        const newObj = {
                            value: individualClassData.id,
                            label: individualClassData.class
                        }
                        getClassArr.push(newObj);
                    });

                    let selectedClasses = getClassArr.map((item) => item.value);


                    //section selection

                    let uniqueSections = [];

                    if (selectedClasses.length > 0) {
                        selectedExamsValues.map((val) => {
                            selectedClasses.map((val1) => {
                                let individualsectionValues = [...new Set(this.props.globals.b_e_c_s_data.filter((item) => item.branch_id == this.state.branchSearch && item.exam_id == parseInt(val) && item.class_id == parseInt(val1)).map((item1) => item1.section_id))].sort();
                                if (individualsectionValues.length > 0) {
                                    uniqueSections.push(...individualsectionValues)
                                }
                            })
                        });
                    }

                    if (uniqueSections.length > 0) {
                        [...new Set(uniqueSections)].map((val) => {
                            let individualSectionData = this.props.globals.globalSections.find((item1) => item1.id == val);
                            const newObj = {
                                value: individualSectionData.id,
                                label: individualSectionData.section_name
                            }
                            getSectionArr.push(newObj);
                        });
                    }
                }

                this.setState({
                    examSelectedvalue: examSelectedvalue,
                    examError: "",
                    getClassArr: getClassArr,
                    classError:"",
                    classSelectedvalue: getClassArr,
                    getSectionArr: getSectionArr,
                    sectionSelectedvalue: getSectionArr,
                    sectionError:"",
                    fromDateError:"",
                    toDateError:"",
                    fromDate:"",
                    toDate:""

                });
            } else {
                this.setState({
                    examSelectedvalue: [],
                    examError:"",
                    getClassArr: [],
                    classSelectedvalue: [],
                    classError:"",
                    getSectionArr: [],
                    sectionSelectedvalue: [],
                    sectionError:"",
                    fromDateError:"",
                    toDateError:"",
                    fromDate:"",
                    toDate:""

                });
            }
        }

        if (name == "section") {

            let sectionSelectedvalue = [];

            if (e != null) {
                for (let i = 0; i < e.length; i++) {
                    const sectionval = e[i];
                    const newObj = {
                        label: sectionval.label,
                        value: sectionval.value,
                    }
                    sectionSelectedvalue.push(newObj);
                }
                this.setState({
                    sectionSelectedvalue: sectionSelectedvalue,
                    sectionError: "",
                    fromDateError:"",
                    toDateError:"",
                    fromDate:"",
                    toDate:""
                });
            }
        }
    }


    dropDownGetValues(fieldname) {
        let getArray = [];
        if (fieldname == "branchSearch") {
            this.props.globals.globalBranches.map((stumap) => {
                const newObj = {
                    value: stumap.id,
                    label: stumap.branch_name
                }
                getArray.push(newObj);
            });
        }
        return getArray;
    }

    selecthandleInputChange = (e) => {
        let name = e.target.name
        let value = e.target.value

        if (name == "fromDate") {
            this.setState({
                fromDateError: ""
            })
        }
        if (name == "toDate") {
            this.setState({
                toDateError: ""
            })
        }
        if (name == "reqMessage") {
            this.setState({
                reqMessage: value,
            })
        }
        if (name == "eventName") {
            this.setState({
                eventError: "",
            })
        }

        this.setState({ [name]: value });
    }

    selecthandleBranch = (name, value) => {

        if (name == "branchSearch") {
            if (value != "0") {
                let branchSearchData = this.props.globals.globalBranches.find((a) => a.id == value);
                console.log("branchSearchData", branchSearchData);

                let getExamArr = [];
                let getClassArr = [];
                let getSectionArr = [];

                if (branchSearchData != null) {
                    // Exams selection
                    let uniqueExams = [...new Set(this.props.globals.b_e_c_s_data.filter((item) => item.branch_id == branchSearchData.id).map((item1) => item1.exam_id))].sort();

                    uniqueExams.map((val) => {
                        let individualExamData = this.props.globals.exams.find((item1) => item1.id == val);
                        const newObj = {
                            value: individualExamData.id,
                            label: individualExamData.exam
                        }
                        getExamArr.push(newObj);
                    });

                    //Class selection

                    let selectedExamsValues = getExamArr.map((item) => item.value);

                    let uniqueClasses = [];

                    if (selectedExamsValues.length > 0) {

                        selectedExamsValues.map((val) => {
                            let individualClassValues = [...new Set(this.props.globals.b_e_c_s_data.filter((item) => item.branch_id == branchSearchData.id && item.exam_id == parseInt(val)).map((item1) => item1.class_id))].sort();
                            uniqueClasses.push(...individualClassValues)
                        });
                    }

                    if (uniqueClasses.length > 0) {
                        [...new Set(uniqueClasses)].map((val) => {
                            let individualClassData = this.props.globals.educationalClasses.find((item1) => item1.id == val);
                            const newObj = {
                                value: individualClassData.id,
                                label: individualClassData.class
                            }
                            getClassArr.push(newObj);
                        });

                        let selectedClasses = getClassArr.map((item) => item.value);


                        //section selection

                        let uniqueSections = [];

                        if (selectedClasses.length > 0) {
                            selectedExamsValues.map((val) => {
                                selectedClasses.map((val1) => {
                                    let individualsectionValues = [...new Set(this.props.globals.b_e_c_s_data.filter((item) => item.branch_id == branchSearchData.id && item.exam_id == parseInt(val) && item.class_id == parseInt(val1)).map((item1) => item1.section_id))].sort();
                                    if (individualsectionValues.length > 0) {
                                        uniqueSections.push(...individualsectionValues)
                                    }
                                })
                            });
                        }

                        if (uniqueSections.length > 0) {
                            [...new Set(uniqueSections)].map((val) => {
                                let individualSectionData = this.props.globals.globalSections.find((item1) => item1.id == val);
                                const newObj = {
                                    value: individualSectionData.id,
                                    label: individualSectionData.section_name
                                }
                                getSectionArr.push(newObj);
                            });
                        }
                    }

                    this.setState({
                        branchSearchval: {
                            value: branchSearchData.id,
                            label: branchSearchData.branch_name
                        },
                        branch: branchSearchData.branch_name,
                        branchError: "",
                        getExamArr: getExamArr,
                        examSelectedvalue: getExamArr,
                        getClassArr: getClassArr,
                        classSelectedvalue: getClassArr,
                        getSectionArr: getSectionArr,
                        sectionSelectedvalue: getSectionArr,
                        examError:"",
                        classError:"",
                        sectionError:"",
                        eventError:"",
                        fromDateError:"",
                        toDateError:"",
                        fromDate:"",
                        toDate:""

                    });
                }

            }
        }

        this.setState({ [name]: value });
    }


    handleFormSubmit = e => {

        if (this.state.eventName == "") {
            this.setState({ eventError: "Please enter event name" });
            return ""
        }

        if (!this.state.examSelectedvalue.length) {
            this.setState({ examError: "Please select exam" });
            return ""
        }

        if (!this.state.classSelectedvalue.length) {
            this.setState({ classError: "Please select class" });
            return ""
        }

        if (!this.state.sectionSelectedvalue.length) {
            this.setState({ sectionError: "Please select section" });
            return ""
        }

        if (this.state.fromDate == "") {
            this.setState({ fromDateError: "Please select from date", })
            return ""
        }
        if (this.state.toDate == "") {
            this.setState({ toDateError: "Please select to date", })
            return ""

        }



        this.setState({
            loader: 1
        });

        const params = {
            institute_id: parseInt(Cookies.get("institutionid")),
            branch_id: this.state.branchSearch.toString(),
            class_id: this.state.classSelectedvalue.map((item) => item.value).toString(),
            exam_id: this.state.examSelectedvalue.map((item) => item.value).toString(),
            section_id: this.state.sectionSelectedvalue.map((item) => item.value).toString(),
            from_datetime: moment(this.state.fromDate, 'YYYY-MM-DD HH:mm:ss').unix().toString(),
            to_datetime: moment(this.state.toDate, 'YYYY-MM-DD HH:mm:ss').unix().toString(),
            request_message: this.state.requestMessage,
            request_title: this.state.eventName.toString(),
            approved_by:parseInt(Cookies.get("id"))
        };

        this.createGroupWisePermissions(
            params
        ).catch(error => {
            console.log("catch if error");
            console.log(error);
            this.setState({
                submitError: error.graphQLErrors.map(x => x.message),
                loader: 0
            });
            console.error("ERR =>", error.graphQLErrors.map(x => x.message));
        });
        this.setState({ loader: 1 })
    };

    createGroupWisePermissions = async (
        params) => {
        await this.props.createGroupWisePermissions({
            variables: {
                params,
            },
            update: (store, { data }) => {
                console.log("data.finishTest", data);
                if (data.createGroupWisePermissions) {
                    this.setState({
                        loader: 0,
                        submitted: true
                    })
                    setTimeout(() => {
                        this.props.onHide();
                        window.location.reload(false);
                    }, 1500);
                }
            }

        });
    };


    render() {
        // console.log("glo", this.props.getParentsPermissionDetails)
        console.log("mahesh", this.state)

        let examselectall = true;
        let examlabelledBy = "Select";
        let examdisableSearch = false;

        let classselectall = true;
        let classlabelledBy = "Select";
        let classdisableSearch = false;

        let sectionselectall = true;
        let sectionlabelledBy = "Select";
        let sectiondisableSearch = false;

        if (this.props.globals.classes.length > 0) {
            classselectall = true;
            classdisableSearch = false;
        }
        else {
            classdisableSearch = true;
            classselectall = false;
            classlabelledBy = "Class"
        }


        if (this.props.globals.exams.length > 0) {
            examselectall = true;
            examdisableSearch = false;
        }
        else {
            examdisableSearch = true;
            examselectall = false;
            examlabelledBy = "Exam"
        }

        if (this.props.globals.globalSections.length > 0) {
            sectionselectall = true;
            sectiondisableSearch = false;
        }
        else {
            sectiondisableSearch = true;
            sectionselectall = false;
            sectionlabelledBy = "Section"
        }


        return (

            <Container>
                <Row className=''>

                    <Col sm={12}>
                        <Modal
                            {...this.props}
                            size="lg"
                            aria-labelledby="example-modal-sizes-title-lg"
                        >
                            <Modal.Header closeButton>
                                <Modal.Title className="modal-title">Multi Request</Modal.Title>
                            </Modal.Header>
                            <Modal.Body>
                                <Form>
                                    <Form.Row>
                                        <Col sm={6}>
                                            <h6 className='font-weight-bold'>Event Name </h6>
                                            <input type="text" className='form-control w-100' placeholder='Enter Event Name' name='eventName' onChange={this.selecthandleInputChange} />
                                            <Form.Text className="form-text text-danger">
                                            {this.state.eventError}
                                            </Form.Text>
                                        </Col>
                                    </Form.Row>
                                    <Form.Row>

                                        <Form.Group as={Col} lg={6} md={12} sm={12} controlId="SelectBranch">
                                            <Form.Label className="font-weight-bold">Branch</Form.Label>
                                            <SelectDropDown
                                                stateData={this.state.branchSearchval}
                                                handleChange={this.selecthandleBranch}
                                                name="branchSearch"
                                                options={this.dropDownGetValues("branchSearch")}
                                                placeholderName={'Branch'}
                                                dropdownIndicator={{ DropdownIndicator }}
                                            />
                                        </Form.Group>
                                        <Form.Group as={Col} lg={6} md={12} sm={12} controlId="SelectExam">
                                            <Form.Label className="font-weight-bold">Exam</Form.Label>
                                            <MultiSelect
                                                overrideStrings={{
                                                    "allItemsAreSelected": "All Exams are selected.",
                                                    "selectSomeItems": examlabelledBy
                                                }
                                                }
                                                disableSearch={examdisableSearch}
                                                hasSelectAll={examselectall}
                                                options={this.state.getExamArr}
                                                value={this.state.examSelectedvalue}
                                                onChange={(e) => this.handleMultipleSelectInputChange(e, "exam")}
                                                labelledBy={"exam"}
                                            />
                                            <Form.Text className="form-text text-danger">
                                                {this.state.examError}
                                            </Form.Text>
                                        </Form.Group>
                                        <Form.Group as={Col} lg={6} md={12} sm={12} controlId="SelectClass">
                                            <Form.Label className="font-weight-bold">Class</Form.Label>
                                            <MultiSelect
                                                overrideStrings={{
                                                    "allItemsAreSelected": "All Classes are selected.",
                                                    "selectSomeItems": classlabelledBy
                                                }
                                                }
                                                disableSearch={classdisableSearch}
                                                hasSelectAll={classselectall}
                                                options={this.state.getClassArr}
                                                value={this.state.classSelectedvalue}
                                                onChange={(e) => this.handleMultipleSelectInputChange(e, "class")}
                                                labelledBy={"class"}
                                            />
                                            <Form.Text className="form-text text-danger">
                                                {this.state.classError}
                                            </Form.Text>
                                        </Form.Group>
                                        <Form.Group as={Col} lg={6} md={12} sm={12} controlId="SelectSection">
                                            <Form.Label className="font-weight-bold">Section</Form.Label>
                                            <MultiSelect
                                                overrideStrings={{
                                                    "allItemsAreSelected": "All Sections are selected.",
                                                    "selectSomeItems": sectionlabelledBy
                                                }
                                                }
                                                disableSearch={sectiondisableSearch}
                                                hasSelectAll={sectionselectall}
                                                options={this.state.getSectionArr}
                                                value={this.state.sectionSelectedvalue}
                                                onChange={(e) => this.handleMultipleSelectInputChange(e, "section")}
                                                labelledBy={"section"}
                                            />
                                            <Form.Text className="form-text text-danger">
                                                {this.state.sectionError}
                                            </Form.Text>
                                        </Form.Group>

                                    </Form.Row>
                                </Form>
                                <section>
                                    <Row className=''>
                                        <Col as={Col} lg={6} md={12} sm={12}>
                                            <div>
                                                <div className=' font-weight-bold'><label>From Date</label></div>
                                                <input type='datetime-local' className='form-control' name="fromDate" onChange={this.selecthandleInputChange} style={{ width: "180px" }} />
                                            </div>
                                            <Form.Text className="form-text text-danger">
                                            {this.state.fromDateError}
                                            </Form.Text>
                                        </Col>
                                        <Col as={Col} lg={6} md={12} sm={12}>
                                            <div>
                                                <div className=' font-weight-bold'><label>To Date</label></div>
                                                <input type='datetime-local' className='form-control' name="toDate" onChange={this.selecthandleInputChange} style={{ width: "180px" }} />
                                            </div>
                                            <Form.Text className="form-text text-danger">
                                            {this.state.toDateError}
                                            </Form.Text>
                                        </Col>
                                    </Row>
                                    <Row className='mt-4'>
                                        <Col as={Col} lg={6} md={12} sm={12}>
                                            <div className=' font-weight-bold'><label>Request message</label></div>
                                            <textarea className='form-control' name="requestMessage" onChange={this.selecthandleInputChange} style={{ width: "300px" }}></textarea>
                                        </Col>
                                        <Col as={Col} lg={6} md={12} sm={12} >
                                            <Button className=' btn btn-dark multi_submit_btn' style={{ marginTop: "87px" }} onClick={this.handleFormSubmit}>
                                                {
                                                    this.state.loader == 1 ? (
                                                        <span className="spinner-border spinner-border-sm"></span>
                                                    ) : ""
                                                }Send Request</Button>
                                            <div className='d-block'>
                                                {
                                                    this.state.submitted == true ? (
                                                        <p className="text-success mt-3" style={{marginLeft:"250px"}}>Successfully Sent</p>
                                                    ) : ""
                                                }
                                                {
                                                    this.state.submitError != "" ? (
                                                        <span className="text-danger mt-1">{this.state.submitError}</span>
                                                    ) : ("")
                                                }
                                            </div>
                                        </Col>
                                    </Row>
                                </section>
                            </Modal.Body>
                        </Modal>
                    </Col>
                </Row>
            </Container>


        )
    }
}

export default
    withRouter(compose(
        graphql(ADD_CREATE_GROUP_WISE_PERMISSIONS, {
            name: "createGroupWisePermissions"
        })

    )(MultipleRequestModal));